// extracted by mini-css-extract-plugin
module.exports = {"links":"gov-links_links__VCu40","link":"gov-links_link__ZDaq2"};